import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService } from 'hisng';

@Injectable()
export class RepositoryImportService {

    constructor( private backendService: HisBackendService ) { }

    doImportFromRepository( url: string, dateFrom: string, type: string ): Observable<number> {
        return this.backendService.postData( `api/v1/fs/res/publication/import/fromRepository/${dateFrom}/${type}`, url );
    }
}
